<template>
    <!-- <v-container class="boxed"> -->
        <div class="interview-nav-list">
            <div
                v-for="(question, index) in questions"
                :key="question.sort"
                class="interview-nav-item"
            >
                <div class="icon-wrapper">
                    <fai
                        class="multistep-icon"
                        :class="{
                            selected: question.sort == selected,
                            pending: questions.findIndex(x => x.sort == selected) < index
                        }"
                        :icon="getIcon(question)"
                    ></fai>
                </div>
                <div
                    v-if="index < questions.length - 1"
                    class="nav-item-seperator hidden-sm-and-down"
                    :class="{
                        'seperator-selected': questions[index + 1].sort == selected,
                        'seperator-pending': questions.findIndex(x => x.sort == selected) <= index
                    }"
                ></div>
            </div>
        </div>
    <!-- </v-container> -->
</template>
<script>
export default {
    props: {
        selected: [String, Number],
        questions: Array,
        stage_key: String,
        application_id: String
    },
    methods: {
        questionLink: function(q) {
            this.$router.push({
                // name: `/stage/${this.stage_key}/${q.sort.toString()}`
                name: "stage.question",
                params: {
                    sort: q.sort.toString(),
                    stage_key: this.stage_key,
                    application_id: this.application_id
                }
            });
        },
        getIcon: function(question) {
            return question.sort >= this.selected
              ? question.sort === this.selected
                  ? 'question-circle'
                  : 'minus-circle'
              : 'check-circle';
        }
    }
}
</script>
<style lang="scss">
.selected {
    color: $go-orange !important;
}

.seperator-selected {
    background-color: $go-orange !important;
}

.interview-nav-list {
    list-style-type: none;
    text-align: center;
    justify-content: center;
    flex-direction: row;
    display: flex;
}

.interview-nav-item {
    padding-top: 10px;
    padding-bottom: 10px;
    font-weight: bold;
    display: inline-block;
}

.icon-wrapper {
    text-align: center;
    padding-top: 10px;
    padding-bottom: 10px;
    font-weight: bold;
    display: inline-block;
    width: 100px;
}

.nav-item-seperator {
    min-width: 60px;
    height: 4px;
    background-color: $go-dark-grey;
    display: inline-block;
    /* margin-left: -5px; */
    margin-bottom: 25px;
    margin-right: -26px;
    margin-left: -26px;
}

// .interview-nav-item:hover {
//     cursor: pointer;
// }

.boxed {
    /* border-left: 0.5px solid #EAEAEA;
    border-right: 0.5px solid #EAEAEA; */
    height: 100%;
}

.step-title {
    color: $go-dark-grey !important;
    font-family: $secondary-font !important;
}

.multistep-icon {
    font-size: 48px;
    margin: auto;
    margin-bottom: 10px;
    color: $go-dark-grey;
    /* padding: none;
    margin: none; */
}

.pending {
    color: $go-light-grey !important;
}

.seperator-pending {
    background-color: $go-light-grey !important;
}
</style>
